import { connect } from 'react-redux';

import {
  getAllBoardgames,
  markBoardgameAsSelection,
  setBoardgameVisibility,
} from '../actions/boardgames';

import { allBoardgamesSelector } from '../reducers/boardgames';

import AdminBoardgamesListPageComponent from '../components/AdminBoardgamesListPage';

const mapStateToProps = state => {
  return {
    boardgames: allBoardgamesSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    getAllBoardgames: () => dispatch(getAllBoardgames()),
    markBoardgameAsSelection: (bg, selection) => dispatch(markBoardgameAsSelection(bg, selection)),
    setBoardgameVisibility: (bg, visible) => dispatch(setBoardgameVisibility(bg, visible)),
  };
};

const AdminBoardgamesListPage = connect(mapStateToProps, mapDispatchToProps)(AdminBoardgamesListPageComponent);

export default AdminBoardgamesListPage;
